import { Injectable } from '@angular/core';
import { ApiBaseService } from "../../core/services/api-base.service";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { UserService } from "../../core/services/user.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { Status } from "../models/status.model";
import { catchError, map, tap } from "rxjs/operators";
import { ModelMapperService } from "./mapper/model-mapper.service";
import Utils from "../utils/utils";
import { BaseFilesModel } from "../models/base-files.model";
import { CommunityServerConfigModel } from "../models/community-server-config.model";
import { ConfigurationService } from "./configuration.service";

@Injectable()
export class CommunityServerConfigService extends ApiBaseService<CommunityServerConfigModel> {

  constructor(protected http: HttpClient,
              protected router: Router,
              protected userService: UserService,
              private config: ConfigurationService,
              protected modalService: NgbModal,
              private modelMapper: ModelMapperService) {
    super(CommunityServerConfigModel, 'config', http, router, userService);
    this.modalService = modalService;
    // this.url = AppConfig.SYNC_SERVER + AppConfig.SYNC_BASE_URL;
    this.url = this.config.getApiConfig().communityUrl;
  }

  /**
   * Get a single entry
   */
  public getConfigForTenant(tenantId: string, status?: Status, path?: string): Observable<CommunityServerConfigModel> {

    const url = `${path ? path : this.url}/config/${tenantId}`;

    status = status || new Status();
    status.setLoading();

    return this.http.get(url).pipe(
      map(response => {
        if (this.checkJSON(response)) {
          status.setSuccess();
          return this.fromJSON(response);
        } else {
          status.setNoResults();
        }
      }),
      catchError(err => this.handleError(err, status)),);
  }

  /**
   * Create / Update specific entry
   */
  update(model: CommunityServerConfigModel, status?: Status, path?: string): Observable<CommunityServerConfigModel> {
    status = status || new Status();
    status.setLoading();

    const url = `${path ? path : this.url}/config/${model.id}`;

    if (this.userService) {
      this.userService.addCurrentUser(model);
    }

    return this.http[Utils.isValidId(model.id) ? 'put' : 'post'](
      url,
      Utils.isValidId(model.id) ? {$set: model.toJSON()} : model.toJSON()
    ).pipe(
      map(response => {

        if (model.id || this.checkJSON(response)) {
          status.setSuccess();
          return model.id ? model : this.fromJSON(response);
        } else {
          status.setError();
        }
      }),
      tap(() => {
        if (this.fileService && model instanceof BaseFilesModel
          && model.filesToDelete && model.filesToDelete.length > 0) {
          for (const file of model.filesToDelete) {
            this.fileService.delete(file.href, true)
              .then(() => {
              }, () => {
              });
          }
        }
      }),
      catchError(err => this.handleError(err, status)),);
  }

  /**
   * Create a default config for the selected tenant
   */
  // public createDefaultConfigForTenant(tenantId: string, status?: Status): Observable<ServerConfigModel> {
  //   const url = `${this.url}/cms-server/${tenantId}`;
  //
  //   status = status || new Status();
  //   status.setLoading();
  //
  //   return this.http.post(url, {}).pipe(
  //     map(response => {
  //       if (this.checkJSON(response)) {
  //         status.setSuccess();
  //         return this.fromJSON(response);
  //       } else {
  //         status.setNoResults();
  //       }
  //     }),
  //     catchError(err => this.handleError(err, status)),);
  // }

  checkJSON(json: any): boolean {
    return this.modelMapper.communityServerConfigCheckJSON(json);
  }

  emptyModel(): CommunityServerConfigModel {
    return this.modelMapper.communityServerConfigEmptyModel();
  }

  fromJSON(json: any, skipCheck?: boolean): CommunityServerConfigModel {
    return this.modelMapper.communityServerConfigFromJSON(json, skipCheck);
  }
}
